import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_instructions_real'
const STORAGE_KEY_MAP = 'tr_v3_instructions_map_real'

const defaultInstruction = {
  instruction_id: 1,
  title: '评估说明',
  content: '请根据您对该员工的日常观察，客观勾选以下行为指标。',
  status: 1,
  is_active: 1
}

export default {
  state: {
    instructionsMap: { '1': [defaultInstruction] },
    instructions: [defaultInstruction],
    defaultInstructions: [defaultInstruction]
  },
  mutations: {
    SET_INSTRUCTIONS(state, list) {
      state.instructions = list
      state.instructionsMap['1'] = list
      storage.set(STORAGE_KEY, list)
      storage.set(STORAGE_KEY_MAP, state.instructionsMap)
    },
    SET_INSTRUCTIONS_FOR_TASK(state, { taskId, instructions }) {
      const tid = String(taskId || '1')
      state.instructionsMap[tid] = instructions
      state.instructions = instructions
      storage.set(STORAGE_KEY_MAP, state.instructionsMap)
      storage.set(STORAGE_KEY, instructions)
    },
    LOAD_TASK_INSTRUCTIONS(state, taskId) {
      const tid = String(taskId || '1')
      const taskInstr = state.instructionsMap[tid]
      if (taskInstr) {
        state.instructions = taskInstr
      } else {
        const cloned = JSON.parse(JSON.stringify(state.defaultInstructions))
        state.instructionsMap[tid] = cloned
        state.instructions = cloned
        storage.set(STORAGE_KEY_MAP, state.instructionsMap)
      }
    },
    ADD_INSTRUCTION(state, item) {
      state.instructions.push(item)
      storage.set(STORAGE_KEY, state.instructions)
    },
    UPDATE_INSTRUCTION(state, item) {
      const idx = state.instructions.findIndex(i => i.instruction_id === item.instruction_id)
      if (idx >= 0) {
        state.instructions.splice(idx, 1, item)
        storage.set(STORAGE_KEY, state.instructions)
      }
    },
    DELETE_INSTRUCTION(state, id) {
      state.instructions = state.instructions.filter(i => i.instruction_id !== id)
      storage.set(STORAGE_KEY, state.instructions)
    },
    SET_ACTIVE_INSTRUCTION(state, id) {
      state.instructions.forEach(i => {
        if (i.status === 1) {
          i.is_active = (i.instruction_id === id) ? 1 : 0
        }
      })
      storage.set(STORAGE_KEY, state.instructions)
    },
    TOGGLE_INSTRUCTION_STATUS(state, id) {
      const item = state.instructions.find(i => i.instruction_id === id)
      if (!item) return
      const newStatus = item.status === 1 ? 0 : 1
      item.status = newStatus
      if (newStatus === 0 && item.is_active === 1) {
        item.is_active = 0
        const otherEnabled = state.instructions.find(i => i.status === 1 && i.instruction_id !== id)
        if (otherEnabled) {
          otherEnabled.is_active = 1
        }
      }
      storage.set(STORAGE_KEY, state.instructions)
    }
  },
  getters: {
    allInstructions: state => state.instructions,
    activeInstruction: state => state.instructions.find(i => i.is_active === 1 && i.status === 1) || state.instructions[0] || null
  }
}
